import { render, staticRenderFns } from "./SetStandardDialog.vue?vue&type=template&id=f6fd6c94"
import script from "./SetStandardDialog.vue?vue&type=script&lang=js"
export * from "./SetStandardDialog.vue?vue&type=script&lang=js"
import style0 from "./SetStandardDialog.vue?vue&type=style&index=0&id=f6fd6c94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports